// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'car';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M15.75 7.313 14.475 4.47a1.686 1.686 0 0 0-1.582-1.095H5.107A1.687 1.687 0 0 0 3.525 4.47L2.25 7.313m-1.125 5.038v1.15a1.125 1.125 0 0 0 2.25 0v-1.126m13.5-.024v1.15a1.125 1.125 0 0 1-2.25 0v-1.126' />
    <path d='M2.063 7.313h13.874a1.5 1.5 0 0 1 1.5 1.5v2.812a.75.75 0 0 1-.75.75H1.313a.75.75 0 0 1-.75-.75V8.812a1.5 1.5 0 0 1 1.5-1.5z' />
    <path d='M3.094 10.125a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m11.812.563a.281.281 0 0 1 0-.563m0 .563a.281.281 0 1 0 0-.563' />
  </g>
);

export const viewBox = '0 0 18 18';
